import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { DrawdownDates } from '../types';

interface DrawdownDateInputsProps {
  drawdownDates: DrawdownDates | null;
  dueDate: string;
  onDueDateChange: (date: string) => void;
}

export function DrawdownDateInputs({
  drawdownDates,
  dueDate,
  onDueDateChange,
}: DrawdownDateInputsProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Issue Date (Read-only) */}
      <div className="space-y-2">
        <Label htmlFor="issue-date">Drawdown Issue Date</Label>
        <Input
          id="issue-date"
          type="date"
          value={drawdownDates?.issue_date || ''}
          readOnly
          disabled
        />
      </div>

      {/* Due Date Input */}
      <div className="space-y-2">
        <Label htmlFor="due-date">Due Date for New Investors</Label>
        <Input
          id="due-date"
          type="date"
          value={dueDate}
          onChange={(e) => onDueDateChange(e.target.value)}
        />
      </div>
    </div>
  );
}
